export default function Warning() {
  return (
    <svg
      className="stroke-current stroke-[35]"
      viewBox="48 48 928 928"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          className="fill-current"
          d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768zm48-176a48 48 0 1 1-96 0 48 48 0 0 1 96 0zm-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32z"
        />
      </g>
    </svg>
  );
};